import { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useTranslationNamespace } from 'shared/helper/app-helper';
import { Footer } from 'shared/layout/footer';
import { Navbar } from 'shared/layout/navbar';
import { NormalLayoutProps } from 'shared/types/layout.type';
import resources from './loc';

const NormalLayout: FC<NormalLayoutProps> = ({ children, navbarDisplay = true, footerDisplay = true, navbarType, showTopNavBar }) => {
	const [searchParams] = useSearchParams();
	const { ready } = useTranslationNamespace('layout', resources);

	useEffect(() => {
		const referral_id = searchParams.get('referralId');
		if (referral_id) {
			localStorage.setItem('referralId', referral_id);
		}
	}, [searchParams.get('referralId')]);

	return ready ? (
		<>
			{navbarDisplay && <Navbar navbarType={navbarType} showTopNavBar={showTopNavBar} />}
			{children}
			{footerDisplay && <Footer />}
		</>
	) : (
		<></>
	);
};

export default NormalLayout;
